/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramSupportContactsControllerCreateMutationRequest,
  TelegramSupportContactsControllerCreateMutationResponse,
  TelegramSupportContactsControllerCreate401,
} from '../types/TelegramSupportContactsControllerCreate.ts';

function getTelegramSupportContactsCreateUrl() {
  const res = { method: 'POST', url: `/api/telegram/support-contacts` as const };
  return res;
}

/**
 * {@link /api/telegram/support-contacts}
 */
export async function telegramSupportContactsCreate(
  data: TelegramSupportContactsControllerCreateMutationRequest,
  config: Partial<RequestConfig<TelegramSupportContactsControllerCreateMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramSupportContactsControllerCreateMutationResponse,
    ResponseErrorConfig<TelegramSupportContactsControllerCreate401>,
    TelegramSupportContactsControllerCreateMutationRequest
  >({ method: 'POST', url: getTelegramSupportContactsCreateUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
